import {Injectable, Injector} from '@angular/core';
import {Resource, ResourceParams, ResourceAction, ResourceMethod} from 'ng2-resource-rest';
import {RequestMethod, Http} from '@angular/http';

export class AppSettings {
   public static API_ENDPOINT: string = '/api/';
   public static UPLOADS_ENDPOINT: string = '/uploads/';
}

@Injectable()
@ResourceParams({
  url: AppSettings.API_ENDPOINT + ''
})
export class LandingpageResource extends Resource {
  constructor(http: Http, injector: Injector) {
    super(http, injector);
  }

  @ResourceAction({
    method: RequestMethod.Get,
    isArray: false,
    path: '/contact/{token}'
  })
  getContact: ResourceMethod<{token: any}, any>;
}



// WEBPACK FOOTER //
// ./src/app/landingpage/landingpage.resource.ts